export default __webpack_public_path__ + "static/media/180.18402136.png";